import { memo } from 'react'

import { ReceiptLongOutlined } from '@mui/icons-material'
import { Box, Chip, Skeleton, Tooltip, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { eventQueryKeys } from 'services/queryKeys'

export type Props = {
  workspaceId: string
}

const BillableEventCounterRaw = ({ workspaceId }: Props) => {
  const { t } = useTranslation(['entity'])

  const billableCountQuery = useQuery(eventQueryKeys.billableCount({ workspaceId }))

  if (billableCountQuery.isLoading) {
    return <Skeleton variant="rounded" sx={{ ml: 1, width: 150, height: 26, borderRadius: 5 }} />
  }

  const billableCount = billableCountQuery.data?.count ?? 0

  return (
    <Tooltip title={t('entity:smep.billableEventTooltip')} placement="bottom" arrow>
      <Chip
        icon={<ReceiptLongOutlined />}
        size="small"
        variant="outlined"
        color="primary"
        sx={{ ml: 1, '& .MuiChip-label': { display: 'flex', alignItems: 'baseline', columnGap: 0.5 } }}
        label={
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', columnGap: 0.5 }}>
            <Typography component="span" variant="heading-sm">
              {billableCount}
            </Typography>
            <Typography component="span" variant="text-sm" sx={{ color: 'text.secondary' }}>
              {t('entity:smep.billableEvent', { count: billableCount })}
            </Typography>
          </Box>
        }
      />
    </Tooltip>
  )
}

export const BillableEventCounter = memo(BillableEventCounterRaw)
